// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerClickableStyles } from "@awc/App/Components/Header/HeaderClickable";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

headerClickableStyles.clickable = {
    css: css`
        display: flex;
        column-gap: 8px;
        align-items: center;

        ${xScreen("lte", "sm")} {
            column-gap: 0;
            width: 100%;
            justify-content: center;
            &&&.opened .clickable-icon svg {
                color: ${color("common.ui1")};
            }
        }
    `,
};

headerClickableStyles.icon = {
    size: 20,
    color: "common.ui4",
    css: css`
        ${xScreen("lte", "sm")} {
            &,
            svg {
                color: ${color("primary.main")};
            }
        }
    `,
};

headerClickableStyles.arrow = {
    size: 10,
    color: "common.ui4",
};

headerClickableStyles.openColor = "common.ui1";
